import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { WorkOrderItem } from '../WorkOrderItem'
import type { User } from '../../user/User'

/**
 * Arguments for consuming serial numbers during work order fulfillment.
 * Updates InventoryBySerialNumber status from OnHand → Consumed for work order items.
 */
@InputType()
export class ConsumeSerialNumbersForWorkOrderItemsArgs extends ActionArgs {
  @Field(() => [ID])
  workOrderItemIds: string[]

  @Field(() => ID)
  workOrderId: string
}

export type ConsumeSerialNumbersForWorkOrderItemsArgsType = {
  workOrderItems: WorkOrderItem[]
  workOrderId: string
  user: User
}

export interface IConsumeSerialNumbersForWorkOrderItems
  extends IAction<void, ConsumeSerialNumbersForWorkOrderItemsArgsType> {}

